import { ReceptionBookingDetails } from '@models/reception'

export const isBookingEditable = (booking: ReceptionBookingDetails) =>
  ['initial', 'initial_waiting', 'confirmed'].includes(booking.status)

export const isBookingInitial = (booking: ReceptionBookingDetails) =>
  ['initial', 'initial_waiting'].includes(booking.status)
